import React from "react";
import { Mail, Phone, Calendar, Clock, LogOut, User } from "lucide-react";
import NameAvatarComponent from "../../../newComponents/NameAvatar/NameAvatar";
import "./profileCard.css";

interface ProfileCardProps {
  name?: string;
  email?: string;
  phone?: string;
  leaseRemainingMonths?: number | string;
  tenancySince?: string;
  initials?: any;
  onLogout?: () => void;
}

const ProfileCard: React.FC<ProfileCardProps> = ({
  name = "N/A",
  email = "N/A",
  phone = "N/A",
  leaseRemainingMonths = "N/A",
  tenancySince = "N/A",
  initials = "N/A",
  onLogout,
}) => {
  const nameParts = name?.split(" ") || [];
  const firstName = nameParts[0] || "";
  const lastName = nameParts[1] || "";

  return (
    <div className="tenant-profile-card">
      <div className="tenant-profile-card-content">
        <div className="tenant-profile-avatar-wrapper">
          <div className="tenant-profile-avatar-border">
            <NameAvatarComponent
              firstName={firstName}
              lastName={lastName}
              heightWidth={64}
              fontSize="24px"
              backgroundColor="#1A56DB"
              color="#FFFFFF"
            />
          </div>
        </div>

        <div className="tenant-profile-info-section">
          <h2 className="tenant-profile-name">{name}</h2>
          <hr style={{ opacity: 0.2 }} />
          <div className="tenant-profile-info-list">
            <div className="tenant-profile-info-item">
              <Mail className="tenant-profile-info-icon" size={16} />
              <span className="tenant-profile-info-text">{email}</span>
            </div>

            <div className="tenant-profile-info-item">
              <Phone className="tenant-profile-info-icon" size={16} />
              <span className="tenant-profile-info-text">{phone}</span>
            </div>

            {leaseRemainingMonths !== "N/A" && (
              <div className="tenant-profile-info-item">
                <Clock className="tenant-profile-info-icon" size={16} />
                <span className="tenant-profile-info-text">
                  Lease Expiring: {leaseRemainingMonths} Months
                </span>
              </div>
            )}

            {tenancySince !== "N/A" && (
              <div className="tenant-profile-info-item">
                <Calendar className="tenant-profile-info-icon" size={16} />
                <span className="tenant-profile-info-text">
                  Tenancy: {tenancySince}
                </span>
              </div>
            )}

            {/* {initials !== "N/A" && (
              <div className="tenant-profile-info-item">
                <User className="tenant-profile-info-icon" size={16} />
                <span className="tenant-profile-info-text">Initials: {initials}</span>
              </div>
            )} */}
          </div>

          <hr style={{ opacity: 0.2 }} />
        </div>
        <div className="tenant-profile-card-footer">
          <button onClick={onLogout}>
            <LogOut size={18} color="red" /> Logout
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProfileCard;
